import { useSnackbar } from 'notistack';
import { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { io } from 'socket.io-client';
import { addChatNotification, fetchChatUnreadCount } from '../redux/features/socketNotificationSlice';
import { useSelector } from 'react-redux';
const SocketContext = createContext(null);

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const socketRef = useRef(null);
  const openRef = useRef(false);
  const API_URL = process.env.REACT_APP_API_URL;
  const chat = useSelector((state) => state.chat);
  const { totalChatCount } = useSelector((state) => state.socketNotification);
  const { open } = chat;
  const audioRef = useRef(null);

  useEffect(() => {
    dispatch(fetchChatUnreadCount());
  }, [dispatch]);

  useEffect(() => {
    openRef.current = open;
  }, [open]);

  useEffect(() => {
    audioRef.current = new Audio('/sounds/notification.wav');
  }, []);
  useEffect(() => {
    if (socketRef.current) {
      return;
    }

    const token = JSON.parse(localStorage.getItem('cred'))?.token;
    if (!token) return;

    const s = io(`${API_URL}chat`, {
      auth: { token },
      transports: ['websocket'],
    });

    socketRef.current = s;
    setSocket(s);

    s.on('connect', () => {
      console.log('✅ Global socket connected');
    });

    s.on('chat_notification', (data) => {
      if (!openRef.current) {
        const isGroup = data?.type !== 'ONE_TO_ONE';

        const message = isGroup
          ? `${data?.name} (Group): ${data?.message || 'New message'}`
          : `📧 ${data?.name} : ${data?.message || 'New message'}`;
        if (audioRef.current) {
          audioRef.current.play().catch((error) => console.error('Audio play failed', error));
        }

        enqueueSnackbar(message || 'New message received', {
          variant: 'info',
          autoHideDuration: 4000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });
      }

      dispatch(
        addChatNotification({
          id: Date.now(),
          chat_room_id: data.chat_room_id,
          message: data.message,
          sender: data.name,
          type: data.type,
          createdAt: new Date().toISOString(),
          raw: data,
        }),
      );
    });

    return () => {
      s.disconnect();
      socketRef.current = null;
      setSocket(null);
    };
  }, []);

  return <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>;
};
